module.exports = __webpack_public_path__ + "static/media/test11_1.11109227.png";